import { RealEstateInfo } from "Features/CheckPrice/Products/RiskProducts/HouseProducts/House/houseFormValuesInterfaces";
import { MAX_BTA, MAX_BTA_RENTAL } from "../houseConstants";

export const isBtaAboveMax = (value: number): boolean => value > MAX_BTA;

export const isBtaLowerThanValueFromEiendomsverdi = (
  eiendomsVerdi: RealEstateInfo,
  customerBta: number,
): boolean => {
  return (
    eiendomsVerdi.grossArea !== undefined &&
    customerBta < eiendomsVerdi.grossArea
  );
};
export const isAboveRentalBtaMaxSize = (bta: number): boolean =>
  bta > MAX_BTA_RENTAL;
